import { LoadingContext } from "context/LoadingContext";
import { useContext, useEffect } from "react";
import { useMutation } from "react-query";
import { http } from "shared/util/http";

export interface QueryOptions<Trequest = any, Tresponse = any, TContext = any> {
  url: string;
  pathVariables?: string;
  /** Quando true, não exibe o overlay de loading global durante a mutação (evita esconder conteúdo de modais). */
  skipGlobalLoading?: boolean;
  onMutate?: (request: Trequest) => void;
  onSuccess?: (request: Trequest, response: Tresponse, context?: TContext) => void;
  onError?: (data: any) => void;
  onFinaly?: () => void;
}

function usePost<Request, Response = any>(options: QueryOptions) {
  const { reservarCarregamento } = useContext(LoadingContext);
  const skipGlobalLoading = options.skipGlobalLoading === true;

  const mutacao = useMutation({
    mutationFn: async (data: Request) =>
      await http.post<Response>(`${options.url}${options.pathVariables ? "/" + options.pathVariables : ""}`, data),
    onMutate: (request) => {
      if (options.onMutate) {
        options.onMutate(request);
      }
    },
    onSuccess: options.onSuccess,
    onError: options.onError,
    onSettled: () => {
      if (options.onFinaly) {
        options.onFinaly();
      }
    },
  });

  // Mesma armadilha do useFetch: no react-query v3 o `onSettled` é callback do observer e
  // não roda se o componente desmontar durante a requisição — o overlay global ficava
  // ligado cobrindo o sistema inteiro. A liberação agora é cleanup de efeito.
  useEffect(() => {
    if (skipGlobalLoading || !mutacao.isLoading) return;
    return reservarCarregamento();
  }, [mutacao.isLoading, skipGlobalLoading, reservarCarregamento]);

  return mutacao;
}
export default usePost;
